import { useFormikContext } from 'formik';

import {
  Box,
  Button,
  DrawerButtonGroup,
  ListItem,
  Tooltip,
  UnorderedList,
} from '@frontend/legacy-components';

import { FeatureFlag } from 'modules/common/drawers/featureFlagDrawer/const/featureFlags';
import { FeatureFlagFormData } from 'modules/common/drawers/featureFlagDrawer/types';

import { featureFlagsStaticData } from '../const/featureFlags';
import { useFeatureFlagFormContext } from './FormWrapper/FeatureFlagFormContext';

export type FooterContentProps = {
  closeDrawer: () => void;
};

export const FooterContent = ({ closeDrawer }: FooterContentProps) => {
  const {
    featureFlagsQueryResult: { isLoading },
    isSubmitting,
    handleSubmit,
  } = useFeatureFlagFormContext();
  const { isValid, errors } = useFormikContext<FeatureFlagFormData>();

  const isSubmitDisabled = !isValid;

  return (
    <DrawerButtonGroup>
      <Button variant="secondary" onClick={closeDrawer}>
        Cancel
      </Button>
      <Tooltip
        label={
          <Box>
            To save changes, address the issues with the following fields:
            <UnorderedList>
              {Object.keys(errors).map((fieldName) => (
                <ListItem key={fieldName}>
                  {featureFlagsStaticData[fieldName as FeatureFlag].displayName}
                </ListItem>
              ))}
            </UnorderedList>
          </Box>
        }
        isDisabled={!isSubmitDisabled}
        variant="expanded"
      >
        <Button
          variant="primary"
          onClick={() => handleSubmit()}
          isDisabled={isSubmitDisabled}
          isLoading={isSubmitting || isLoading}
        >
          Save
        </Button>
      </Tooltip>
    </DrawerButtonGroup>
  );
};
